import { SxProps, Theme } from '@mui/material';
import { designSearchFieldSx } from './designSearchFieldSx';

const TAG_CHIP_GAP_PX = 4;

// Above the table header, which the dropdown would otherwise sit behind.
const filterPopover: SxProps<Theme> = {
  zIndex: 2
};

const filterIcon: SxProps<Theme> = {
  borderRadius: 1
};

// Full width so the whole row is a click target, not just the label text.
// minWidth 0 lets a long tag ellipsise instead of widening the panel.
const filterOption: SxProps<Theme> = {
  display: 'flex',
  m: 0,
  gap: 1,
  minWidth: 0,
  '& .MuiCheckbox-root': { p: 0 },
  '& .MuiFormControlLabel-label': { minWidth: 0 }
};

// Capped at the space below the header, so the panel never moves over it.
const filterPanel = (maxHeight?: number): SxProps<Theme> => ({
  maxHeight,
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  backgroundColor: 'background.paper',
  p: '20px',
  width: 250,
  boxSizing: 'border-box',
  borderStyle: 'solid',
  borderColor: 'customGrey.dark',
  borderWidth: '1px',
  // Only the tag list shrinks when the panel is capped.
  '& > *': {
    flexShrink: 0
  },
  '& > [data-tag-list]': {
    flexShrink: 1
  },
  ...designSearchFieldSx
});

const filterList: SxProps<Theme> = {
  flex: '1 1 auto',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  maxHeight: 335,
  overflowY: 'auto'
};

const filterMessage: SxProps<Theme> = {
  color: 'customGrey.dark',
  py: 1
};

// The chip list is shared with the candidate profile, which keeps its own
// chip size.
const tagsCell: SxProps<Theme> = {
  width: '100%',
  '& .MuiChip-root.MuiChip-sizeSmall': {
    height: '28px',
    p: '4px 8px',
    borderRadius: '30px'
  },
  '& .MuiChip-root .MuiChip-label': {
    p: 0,
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 500
  }
};

// alignItems so the candidate id sits on the pills' centre line, not their top.
const drawerTags: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: `${TAG_CHIP_GAP_PX}px`,
  mt: 1
};

// The campaign table's cells have no top or bottom padding, so wrapped
// 28px tag chips would touch the row edges.
const campaignTableTagCells: SxProps<Theme> = {
  "& .rdt_TableCell[data-column-id='tags']": {
    py: 1
  }
};

export const conversationTagsSx = {
  campaignTableTagCells,
  filterPopover,
  filterIcon,
  filterOption,
  filterPanel,
  filterList,
  tagsCell,
  filterMessage,
  drawerTags
};
